// This file was automatically generated and should not be edited.

// ====================================================
// Domiain Graph Type and Interface Mappings
// ====================================================

import {
  DomainGraphType,
  DomainGraphInterface,
  InterfaceType,
  ObjectType,
} from 'app-core/framework/CoreObjectConstants';

/** @package */
export const DOMAIN_GRAPH_INTERFACE_INTEGRATION_MAP: Record<InterfaceType, Set<ObjectType>> = {
  [DomainGraphInterface.CAN_EDIT_WORKFLOW_SCHEMA_FIELD_VALUES]: new Set([
    DomainGraphType.WORKFLOW_OUTPUT_SCHEMA,
    DomainGraphType.WORKFLOW_TASK_SCHEMA,
  ]),
  [DomainGraphInterface.COLLABORATABLE]: new Set([
    DomainGraphType.AA_SEQUENCE,
    DomainGraphType.AA_SEQUENCE_SCHEMA,
    DomainGraphType.ANTIBODY,
    DomainGraphType.ANTIBODY_SCHEMA,
    DomainGraphType.CUSTOM_ENTITY,
    DomainGraphType.DNA_OLIGO,
    DomainGraphType.DNA_OLIGO_SCHEMA,
    DomainGraphType.DNA_SEQUENCE,
    DomainGraphType.DNA_SEQUENCE_SCHEMA,
    DomainGraphType.ENTITY_SCHEMA,
    DomainGraphType.ENTRY,
    DomainGraphType.EQUIPMENT_SCHEMA,
    DomainGraphType.FEATURE_LIBRARY,
    DomainGraphType.FOLDER,
    DomainGraphType.MIXTURE,
    DomainGraphType.MIXTURE_SCHEMA,
    DomainGraphType.MOLECULE,
    DomainGraphType.OLIGO_CONJUGATE,
    DomainGraphType.OLIGO_CONJUGATE_SCHEMA,
    DomainGraphType.OLIGO_DUPLEX,
    DomainGraphType.OLIGO_DUPLEX_SCHEMA,
    DomainGraphType.PROJECT,
    DomainGraphType.REGISTRY,
    DomainGraphType.RESULT_SCHEMA,
    DomainGraphType.RNA_OLIGO,
    DomainGraphType.RNA_OLIGO_SCHEMA,
    DomainGraphType.RNA_SEQUENCE,
    DomainGraphType.RNA_SEQUENCE_SCHEMA,
    DomainGraphType.RUN_SCHEMA,
    DomainGraphType.TEMPLATE_COLLECTION,
    DomainGraphType.WORKLIST,
  ]),
  [DomainGraphInterface.CORE_OBJECT_ARCHIVABLE]: new Set([
    DomainGraphType.ANALYSIS_TEMPLATE,
    DomainGraphType.ANALYSIS_TEMPLATE_DATA_FRAME_VARIABLE,
    DomainGraphType.ANALYSIS_TEMPLATE_VARIABLE,
    DomainGraphType.BENCHLING_OBJECT_SCHEMA_V2,
    DomainGraphType.BUSINESS_RULE,
    DomainGraphType.CHART,
    DomainGraphType.DATASET,
    DomainGraphType.EXAMPLE_TYPE,
    DomainGraphType.FILE,
    DomainGraphType.JELLYFISH,
    DomainGraphType.JELLYFISH_SCHEMA,
    DomainGraphType.LIBRARY_PARAMETER_DEFINITION,
    DomainGraphType.MODEL_RUN,
    DomainGraphType.PROCEDURE,
    DomainGraphType.PROCEDURE_FLOWCHART,
    DomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE,
    DomainGraphType.PROCEDURE_RUN,
    DomainGraphType.PROCEDURE_RUN_CONDITION_REPLICATE,
    DomainGraphType.PROCEDURE_STEP_EXECUTION_INSTANCE,
    DomainGraphType.REQUEST_V2_DEFINITION,
    DomainGraphType.REQUEST_V2_SUBMISSION,
    DomainGraphType.SAMPLE_TYPE,
    DomainGraphType.STUDY,
    DomainGraphType.TENTACLE,
    DomainGraphType.TEST_DEFINITION,
    DomainGraphType.UNIT,
    DomainGraphType.UNIT_TYPE,
    DomainGraphType.VALIDATION_RULE,
    DomainGraphType.WORKSHEET,
  ]),
  [DomainGraphInterface.DATA_CATALOG_ITEM]: new Set([DomainGraphType.DATASET, DomainGraphType.FILE]),
  [DomainGraphInterface.HAS_CUSTOM_FIELDS]: new Set([
    DomainGraphType.AA_SEQUENCE,
    DomainGraphType.ANTIBODY,
    DomainGraphType.CUSTOM_ENTITY,
    DomainGraphType.DATASET,
    DomainGraphType.DNA_OLIGO,
    DomainGraphType.DNA_SEQUENCE,
    DomainGraphType.ENTRY,
    DomainGraphType.ENTRY_TEMPLATE,
    DomainGraphType.FILE,
    DomainGraphType.MIXTURE,
    DomainGraphType.MOLECULE,
    DomainGraphType.OLIGO_CONJUGATE,
    DomainGraphType.OLIGO_DUPLEX,
    DomainGraphType.RNA_OLIGO,
    DomainGraphType.RNA_SEQUENCE,
    DomainGraphType.STAGE_ENTRY,
  ]),
  [DomainGraphInterface.HAS_PROVENANCE_URI]: new Set([
    DomainGraphType.AA_SEQUENCE_SCHEMA,
    DomainGraphType.ANALYSIS_TEMPLATE,
    DomainGraphType.ANTIBODY_SCHEMA,
    DomainGraphType.BENCHLING_OBJECT_SCHEMA_V2,
    DomainGraphType.CHART,
    DomainGraphType.DATA_FRAME,
    DomainGraphType.DNA_OLIGO_SCHEMA,
    DomainGraphType.DNA_SEQUENCE_SCHEMA,
    DomainGraphType.DOCUMENT,
    DomainGraphType.DROPDOWN,
    DomainGraphType.ENTITY_SCHEMA,
    DomainGraphType.ENTRY_SUBTEMPLATE,
    DomainGraphType.ENTRY_TEMPLATE,
    DomainGraphType.EQUIPMENT_SCHEMA,
    DomainGraphType.EXAMPLE_TYPE,
    DomainGraphType.FILE,
    DomainGraphType.FORM_DEFINITION,
    DomainGraphType.JELLYFISH_SCHEMA,
    DomainGraphType.MIXTURE_SCHEMA,
    DomainGraphType.OLIGO_CONJUGATE_SCHEMA,
    DomainGraphType.OLIGO_DUPLEX_SCHEMA,
    DomainGraphType.PIPELINE_STEP,
    DomainGraphType.PROCEDURE,
    DomainGraphType.PROCEDURE_METHOD_DEFINITION_VERSION,
    DomainGraphType.PROCEDURE_PARAMETER,
    DomainGraphType.PROCEDURE_PARAMETER_VERSION,
    DomainGraphType.REQUEST_V2_DEFINITION,
    DomainGraphType.RESULT_SCHEMA,
    DomainGraphType.RNA_OLIGO_SCHEMA,
    DomainGraphType.RNA_SEQUENCE_SCHEMA,
    DomainGraphType.SCRATCH_FILE,
    DomainGraphType.TEMPLATE_COLLECTION,
    DomainGraphType.TEST_DEFINITION,
    DomainGraphType.UNIT,
    DomainGraphType.UNIT_TYPE,
    DomainGraphType.WORKFLOW_FLOWCHART_CONFIG_VERSION,
    DomainGraphType.WORKFLOW_TASK_DEFINITION,
    DomainGraphType.WORKFLOW_TASK_DEFINITION_VERSION,
    DomainGraphType.WORKFLOW_TASK_SCHEMA,
  ]),
  [DomainGraphInterface.HAS_SCHEMA]: new Set([
    DomainGraphType.AA_SEQUENCE,
    DomainGraphType.ANTIBODY,
    DomainGraphType.BOX,
    DomainGraphType.CONTAINER,
    DomainGraphType.CUSTOM_ENTITY,
    DomainGraphType.DNA_OLIGO,
    DomainGraphType.DNA_SEQUENCE,
    DomainGraphType.ENTRY,
    DomainGraphType.ENTRY_TEMPLATE,
    DomainGraphType.LOCATION,
    DomainGraphType.MATRIX_PLATE,
    DomainGraphType.MOLECULE,
    DomainGraphType.OLIGO_CONJUGATE,
    DomainGraphType.OLIGO_DUPLEX,
    DomainGraphType.RESULT,
    DomainGraphType.RNA_OLIGO,
    DomainGraphType.RNA_SEQUENCE,
    DomainGraphType.RUN,
    DomainGraphType.STAGE_ENTRY,
    DomainGraphType.STUDY,
    DomainGraphType.WELL_PLATE,
    DomainGraphType.WORKFLOW_TASK,
  ]),
  [DomainGraphInterface.IMMUTABLE_DOMAIN_OBJECT]: new Set([
    DomainGraphType.CONFIG_IMPORT_HISTORY_ENTRY,
    DomainGraphType.PROCEDURE_FLOWCHART_CONFIG_VERSION_PROXY,
    DomainGraphType.PROCEDURE_FLOWCHART_VERSION,
    DomainGraphType.PROCEDURE_METHOD_DEFINITION_VERSION,
    DomainGraphType.PROCEDURE_PARAMETER_VERSION,
    DomainGraphType.PROCEDURE_STEP_DEFINITION_VERSION,
    DomainGraphType.STUDY_ITEM_ASSOCIATION,
  ]),
  [DomainGraphInterface.MUTABLE_DOMAIN_OBJECT]: new Set([
    DomainGraphType.AA_SEQUENCE,
    DomainGraphType.ANALYSIS_TEMPLATE,
    DomainGraphType.ANTIBODY,
    DomainGraphType.APP_DEFINITION,
    DomainGraphType.APP_DEFINITION_VERSION,
    DomainGraphType.ASSEMBLY,
    DomainGraphType.BENCHLING_OBJECT_SCHEMA_V2,
    DomainGraphType.BOX,
    DomainGraphType.BOX_SCHEMA,
    DomainGraphType.CHAT_SESSION,
    DomainGraphType.COLLABORATION,
    DomainGraphType.CONTAINER,
    DomainGraphType.CONTAINER_SCHEMA,
    DomainGraphType.CUSTOM_ENTITY,
    DomainGraphType.CUSTOM_SCHEMA_INTERFACE,
    DomainGraphType.DATA_FRAME,
    DomainGraphType.DATASET,
    DomainGraphType.DNA_OLIGO,
    DomainGraphType.DNA_SEQUENCE,
    DomainGraphType.DOCUMENT,
    DomainGraphType.ENTRY,
    DomainGraphType.ENTRY_SUBTEMPLATE,
    DomainGraphType.ENTRY_TEMPLATE,
    DomainGraphType.ENZYME_LIST,
    DomainGraphType.EXAMPLE_TYPE,
    DomainGraphType.FEATURE_LIBRARY,
    DomainGraphType.FILE,
    DomainGraphType.FORM_DEFINITION,
    DomainGraphType.JELLYFISH,
    DomainGraphType.JELLYFISH_SCHEMA,
    DomainGraphType.LABEL_TEMPLATE,
    DomainGraphType.LADDER,
    DomainGraphType.LIBRARY_PARAMETER_DEFINITION,
    DomainGraphType.LOCATION,
    DomainGraphType.LOCATION_SCHEMA,
    DomainGraphType.MATRIX_PLATE,
    DomainGraphType.MATRIX_PLATE_SCHEMA,
    DomainGraphType.MCP_SERVER_CONFIG,
    DomainGraphType.MCP_SERVER_USER_CONFIG,
    DomainGraphType.MIXTURE,
    DomainGraphType.MOLECULE,
    DomainGraphType.NUCLEOTIDE_ALIGNMENT,
    DomainGraphType.OLIGO_CONJUGATE,
    DomainGraphType.OLIGO_DUPLEX,
    DomainGraphType.PLATE,
    DomainGraphType.PLATE_SCHEMA,
    DomainGraphType.POLICY,
    DomainGraphType.PRINTER,
    DomainGraphType.PROCEDURE,
    DomainGraphType.PROCEDURE_FLOWCHART,
    DomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE,
    DomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE_ASSOCIATION,
    DomainGraphType.PROCEDURE_PARAMETER,
    DomainGraphType.PROCEDURE_PARAMETER_CONFIRMATION_VALUE,
    DomainGraphType.PROCEDURE_PARAMETER_MEASURED_VALUE,
    DomainGraphType.PROCEDURE_PARAMETER_PLANNED_VALUE,
    DomainGraphType.PROCEDURE_RUN,
    DomainGraphType.PROCEDURE_RUN_CONDITION,
    DomainGraphType.PROCEDURE_RUN_CONDITION_REPLICATE,
    DomainGraphType.PROCEDURE_RUN_PLAN,
    DomainGraphType.PROCEDURE_RUN_PLAN_CONDITION,
    DomainGraphType.PROCEDURE_STEP_EXECUTION_INSTANCE,
    DomainGraphType.REQUEST_SCHEMA,
    DomainGraphType.REQUEST_TASK_SCHEMA,
    DomainGraphType.REQUEST_V2_DEFINITION,
    DomainGraphType.REQUEST_V2_SUBMISSION,
    DomainGraphType.RESULT,
    DomainGraphType.RESULT_SCHEMA,
    DomainGraphType.RNA_OLIGO,
    DomainGraphType.RNA_SEQUENCE,
    DomainGraphType.RUN,
    DomainGraphType.RUN_SCHEMA,
    DomainGraphType.SAMPLE_TYPE,
    DomainGraphType.SCRATCH_FILE,
    DomainGraphType.SQL_DASHBOARD,
    DomainGraphType.SQL_DASHBOARD_LINK,
    DomainGraphType.STAGE_ENTRY,
    DomainGraphType.STUDY,
    DomainGraphType.STUDY_SCHEMA,
    DomainGraphType.TEMPLATE_COLLECTION,
    DomainGraphType.TENTACLE,
    DomainGraphType.TEST_DEFINITION,
    DomainGraphType.TEST_ORDER,
    DomainGraphType.TRIAL_SAMPLE_TESTING_STUDY_DESIGN,
    DomainGraphType.UNIT,
    DomainGraphType.UNIT_TYPE,
    DomainGraphType.WELL_PLATE,
    DomainGraphType.WELL_PLATE_SCHEMA,
    DomainGraphType.WORKFLOW_FLOWCHART_CONFIG_VERSION,
    DomainGraphType.WORKLIST,
    DomainGraphType.WORKSHEET,
  ]),
  [DomainGraphInterface.PLATE_SCHEMA_INTERFACE]: new Set([
    DomainGraphType.MATRIX_PLATE_SCHEMA,
    DomainGraphType.WELL_PLATE_SCHEMA,
  ]),
  [DomainGraphInterface.PUBLISHABLE]: new Set([
    DomainGraphType.ENTRY_SUBTEMPLATE,
    DomainGraphType.ENTRY_TEMPLATE,
    DomainGraphType.PROCEDURE,
  ]),
  [DomainGraphInterface.STARRABLE]: new Set([
    DomainGraphType.ANALYSIS_TEMPLATE,
    DomainGraphType.DATASET,
    DomainGraphType.ENTRY,
    DomainGraphType.ENTRY_SUBTEMPLATE,
    DomainGraphType.ENTRY_TEMPLATE,
    DomainGraphType.FILE,
    DomainGraphType.FOLDER,
    DomainGraphType.FORM_DEFINITION,
    DomainGraphType.JELLYFISH,
    DomainGraphType.PROCEDURE,
    DomainGraphType.REQUEST_V2_DEFINITION,
    DomainGraphType.TEMPLATE_COLLECTION,
  ]),
  [DomainGraphInterface.STUDYABLE]: new Set([
    DomainGraphType.AA_SEQUENCE,
    DomainGraphType.ANALYSIS,
    DomainGraphType.ANTIBODY,
    DomainGraphType.ASSEMBLY,
    DomainGraphType.BOX,
    DomainGraphType.CONTAINER,
    DomainGraphType.CUSTOM_ENTITY,
    DomainGraphType.DATASET,
    DomainGraphType.DNA_OLIGO,
    DomainGraphType.DNA_SEQUENCE,
    DomainGraphType.ENTRY,
    DomainGraphType.FILE,
    DomainGraphType.MATRIX_PLATE,
    DomainGraphType.MOLECULE,
    DomainGraphType.OLIGO_CONJUGATE,
    DomainGraphType.OLIGO_DUPLEX,
    DomainGraphType.PLATE,
    DomainGraphType.REQUEST_V2_SUBMISSION,
    DomainGraphType.RNA_OLIGO,
    DomainGraphType.RNA_SEQUENCE,
    DomainGraphType.TEST_ORDER,
    DomainGraphType.WELL_PLATE,
    DomainGraphType.WORKFLOW_TASK,
    DomainGraphType.WORKSHEET,
  ]),
};

/**
 * This file and map are autogenerated by `dev generate graphql`.
 *
 * If the value is incorrect, do one of the following:
 * - update the domain graph SDL file's `@identity(..., pluralized: "<pluralized_name>")` directive
 * - OR add to `DOMAIN_GRAPH_TYPE_TO_API_BASE` in `client/app-core/framework/CoreObjectIntrospectionUtils.ts`
 *
 *  @package
 */
export const DOMAIN_GRAPH_TYPE_TO_DEFAULT_API_BASE: Record<ObjectType, string> = {
  [DomainGraphType.AA_SEQUENCE]: '/1/api/proteins',
  [DomainGraphType.AA_SEQUENCE_SCHEMA]: '/1/api/aa-sequence-schemas',
  [DomainGraphType.ANALYSIS]: '/1/api/analyses',
  [DomainGraphType.ANALYSIS_TEMPLATE]: '/1/api/analysis-templates',
  [DomainGraphType.ANALYSIS_TEMPLATE_DATA_FRAME_VARIABLE]: '/1/api/analysis-template-data-frame-variables',
  [DomainGraphType.ANALYSIS_TEMPLATE_VARIABLE]: '/1/api/analysis-template-variables',
  [DomainGraphType.ANTIBODY]: '/1/api/antibodies',
  [DomainGraphType.ANTIBODY_FORMAT]: '/1/api/antibody-formats',
  [DomainGraphType.ANTIBODY_SCHEMA]: '/1/api/antibody-schemas',
  [DomainGraphType.APP_DEFINITION]: '/1/api/app-definitions',
  [DomainGraphType.APP_DEFINITION_VERSION]: '/1/api/app-definition-versions',
  [DomainGraphType.ASSEMBLY]: '/1/api/assemblies',
  [DomainGraphType.BENCHLING_OBJECT_SCHEMA_V2]: '/1/api/schemas',
  [DomainGraphType.BLOCK_VISUALIZATION]: '/1/api/block-visualizations',
  [DomainGraphType.BOX]: '/1/api/boxes',
  [DomainGraphType.BOX_SCHEMA]: '/1/api/box-schemas',
  [DomainGraphType.BUSINESS_RULE]: '/1/api/business-rules',
  [DomainGraphType.CHART]: '/1/api/charts',
  [DomainGraphType.CHAT_SESSION]: '/1/api/chat-sessions',
  [DomainGraphType.COLLABORATION]: '/1/api/collaborations',
  [DomainGraphType.CONFIG_IMPORT_HISTORY_ENTRY]: '/1/api/config-import-history-entries',
  [DomainGraphType.CONTAINER]: '/1/api/containers',
  [DomainGraphType.CONTAINER_SCHEMA]: '/1/api/container-schemas',
  [DomainGraphType.CUSTOM_ENTITY]: '/1/api/custom-entities',
  [DomainGraphType.CUSTOM_SCHEMA_INTERFACE]: '/1/api/custom-schema-interfaces',
  [DomainGraphType.DATA_FRAME]: '/1/api/data-frames',
  [DomainGraphType.DATASET]: '/1/api/datasets',
  [DomainGraphType.DNA_OLIGO]: '/1/api/sequences',
  [DomainGraphType.DNA_OLIGO_SCHEMA]: '/1/api/dna-oligo-schemas',
  [DomainGraphType.DNA_SEQUENCE]: '/1/api/sequences',
  [DomainGraphType.DNA_SEQUENCE_SCHEMA]: '/1/api/dna-sequence-schemas',
  [DomainGraphType.DOCUMENT]: '/1/api/documents',
  [DomainGraphType.DROPDOWN]: '/1/api/dropdowns',
  [DomainGraphType.ENTITY_SCHEMA]: '/1/api/entity-schemas',
  [DomainGraphType.ENTRY]: '/1/api/entries',
  [DomainGraphType.ENTRY_SUBTEMPLATE]: '/1/api/subtemplates',
  [DomainGraphType.ENTRY_TEMPLATE]: '/1/api/templates',
  [DomainGraphType.ENZYME_LIST]: '/1/api/enzyme-lists',
  [DomainGraphType.EQUIPMENT_SCHEMA]: '/1/api/equipment-schemas',
  [DomainGraphType.EXAMPLE_TYPE]: '/1/api/example-types',
  [DomainGraphType.FEATURE_LIBRARY]: '/1/api/feature-libraries',
  [DomainGraphType.FILE]: '/1/api/files',
  [DomainGraphType.FOLDER]: '/1/api/folders',
  [DomainGraphType.FORM_DEFINITION]: '/1/api/form-definitions',
  [DomainGraphType.INTERNAL_PIPELINE]: '/1/api/internal-pipelines',
  [DomainGraphType.JELLYFISH]: '/1/api/jellyfishes',
  [DomainGraphType.JELLYFISH_SCHEMA]: '/1/api/jellyfish-schemas',
  [DomainGraphType.LABEL_TEMPLATE]: '/1/api/label-templates',
  [DomainGraphType.LADDER]: '/1/api/ladders',
  [DomainGraphType.LIBRARY_PARAMETER_DEFINITION]: '/1/api/library-parameter-definitions',
  [DomainGraphType.LOCATION]: '/1/api/locations',
  [DomainGraphType.LOCATION_SCHEMA]: '/1/api/location-schemas',
  [DomainGraphType.MATRIX_PLATE]: '/1/api/matrix-plates',
  [DomainGraphType.MATRIX_PLATE_SCHEMA]: '/1/api/matrix-plate-schemas',
  [DomainGraphType.MCP_SERVER_CONFIG]: '/1/api/mcp-server-configs',
  [DomainGraphType.MCP_SERVER_USER_CONFIG]: '/1/api/mcp-server-user-configs',
  [DomainGraphType.MIXTURE]: '/1/api/mixtures',
  [DomainGraphType.MIXTURE_SCHEMA]: '/1/api/mixture-schemas',
  [DomainGraphType.MODEL_RUN]: '/1/api/model-runs',
  [DomainGraphType.MOLECULE]: '/1/api/molecules',
  [DomainGraphType.NUCLEOTIDE_ALIGNMENT]: '/1/api/nucleotide-alignments',
  [DomainGraphType.OLIGO_CONJUGATE]: '/1/api/oligo-conjugates',
  [DomainGraphType.OLIGO_CONJUGATE_SCHEMA]: '/1/api/oligo-conjugate-schemas',
  [DomainGraphType.OLIGO_DUPLEX]: '/1/api/oligo-duplexes',
  [DomainGraphType.OLIGO_DUPLEX_SCHEMA]: '/1/api/oligo-duplex-schemas',
  [DomainGraphType.PIPELINE_STEP]: '/1/api/pipeline-steps',
  [DomainGraphType.PLATE]: '/1/api/plates',
  [DomainGraphType.PLATE_SCHEMA]: '/1/api/plate-schemas',
  [DomainGraphType.POLICY]: '/1/api/policies',
  [DomainGraphType.PRINTER]: '/1/api/printers',
  [DomainGraphType.PROCEDURE]: '/1/api/procedures',
  [DomainGraphType.PROCEDURE_FLOWCHART]: '/1/api/procedure-flowcharts',
  [DomainGraphType.PROCEDURE_FLOWCHART_CONFIG_VERSION_PROXY]: '/1/api/procedure-flowchart-config-versions',
  [DomainGraphType.PROCEDURE_FLOWCHART_VERSION]: '/1/api/procedure-flowchart-versions',
  [DomainGraphType.PROCEDURE_METHOD_DEFINITION_VERSION]: '/1/api/procedure-method-definition-versions',
  [DomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE]: '/1/api/procedure-method-execution-instances',
  [DomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE_ASSOCIATION]:
    '/1/api/procedure-method-execution-instance-associations',
  [DomainGraphType.PROCEDURE_PARAMETER]: '/1/api/procedure-parameters',
  [DomainGraphType.PROCEDURE_PARAMETER_CONFIRMATION_VALUE]: '/1/api/procedure-parameter-confirmation-values',
  [DomainGraphType.PROCEDURE_PARAMETER_MEASURED_VALUE]: '/1/api/procedure-parameter-measured-values',
  [DomainGraphType.PROCEDURE_PARAMETER_PLANNED_VALUE]: '/1/api/procedure-parameter-planned-values',
  [DomainGraphType.PROCEDURE_PARAMETER_VERSION]: '/1/api/procedure-parameter-versions',
  [DomainGraphType.PROCEDURE_RUN]: '/1/api/procedure-runs',
  [DomainGraphType.PROCEDURE_RUN_CONDITION]: '/1/api/procedure-run-conditions',
  [DomainGraphType.PROCEDURE_RUN_CONDITION_REPLICATE]: '/1/api/procedure-run-condition-replicates',
  [DomainGraphType.PROCEDURE_RUN_PLAN]: '/1/api/procedure-run-plans',
  [DomainGraphType.PROCEDURE_RUN_PLAN_CONDITION]: '/1/api/procedure-run-plan-conditions',
  [DomainGraphType.PROCEDURE_STEP_DEFINITION_VERSION]: '/1/api/procedure-step-definition-versions',
  [DomainGraphType.PROCEDURE_STEP_EXECUTION_INSTANCE]: '/1/api/procedure-step-execution-instances',
  [DomainGraphType.PROJECT]: '/1/api/projects',
  [DomainGraphType.PUBLISHING_RECORD]: '/1/api/publishing-records',
  [DomainGraphType.REGISTRY]: '/1/api/registries',
  [DomainGraphType.REQUEST_SCHEMA]: '/1/api/request-schemas',
  [DomainGraphType.REQUEST_TASK_SCHEMA]: '/1/api/request-task-schemas',
  [DomainGraphType.REQUEST_V2_DEFINITION]: '/1/api/request-v2-definitions',
  [DomainGraphType.REQUEST_V2_SUBMISSION]: '/1/api/request-v2-submissions',
  [DomainGraphType.RESULT]: '/1/api/results',
  [DomainGraphType.RESULT_SCHEMA]: '/1/api/result-schemas',
  [DomainGraphType.RNA_OLIGO]: '/1/api/sequences',
  [DomainGraphType.RNA_OLIGO_SCHEMA]: '/1/api/rna-oligo-schemas',
  [DomainGraphType.RNA_SEQUENCE]: '/1/api/sequences',
  [DomainGraphType.RNA_SEQUENCE_SCHEMA]: '/1/api/rna-sequence-schemas',
  [DomainGraphType.RUN]: '/1/api/runs',
  [DomainGraphType.RUN_SCHEMA]: '/1/api/run-schemas',
  [DomainGraphType.SAMPLE_DEFINITION]: '/1/api/sample-definitions',
  [DomainGraphType.SAMPLE_TYPE]: '/1/api/sample-types',
  [DomainGraphType.SCRATCH_FILE]: '/1/api/scratch-files',
  [DomainGraphType.SQL_DASHBOARD]: '/1/api/sql-dashboards',
  [DomainGraphType.SQL_DASHBOARD_BLOCK]: '/1/api/sql-dashboard-blocks',
  [DomainGraphType.SQL_DASHBOARD_LINK]: '/1/api/sql-dashboard-links',
  [DomainGraphType.STAGE_ENTRY]: '/1/api/stage-entries',
  [DomainGraphType.STAR]: '/1/api/stars',
  [DomainGraphType.STATIC_SCHEMA_INTERFACE]: '/1/api/static-schema-interfaces',
  [DomainGraphType.STATIC_VALIDATION_RULE_TEMPLATE]: '/1/api/static-validation-rule-templates',
  [DomainGraphType.STUDY]: '/1/api/studies',
  [DomainGraphType.STUDY_ITEM_ASSOCIATION]: '/1/api/study-item-associations',
  [DomainGraphType.STUDY_SAMPLE_TEST_PLAN]: '/1/api/study-sample-test-plans',
  [DomainGraphType.STUDY_SCHEMA]: '/1/api/study-schemas',
  [DomainGraphType.TEAM]: '/1/api/teams',
  [DomainGraphType.TEMPLATE_COLLECTION]: '/1/api/template-collections',
  [DomainGraphType.TENANT_CONFIG]: '/1/api/tenant-configs',
  [DomainGraphType.TENTACLE]: '/1/api/tentacles',
  [DomainGraphType.TEST_DEFINITION]: '/1/api/test-definitions',
  [DomainGraphType.TEST_ORDER]: '/1/api/test-orders',
  [DomainGraphType.TREATMENT_GROUP]: '/1/api/treatment-groups',
  [DomainGraphType.TRIAL_SAMPLE_TESTING_STUDY_DESIGN]: '/1/api/trial-sample-testing-study-designs',
  [DomainGraphType.UNIT]: '/1/api/units',
  [DomainGraphType.UNIT_TYPE]: '/1/api/unit-types',
  [DomainGraphType.USER]: '/1/api/users',
  [DomainGraphType.VALIDATION_RULE]: '/1/api/validation-rules',
  [DomainGraphType.WELL_PLATE]: '/1/api/well-plates',
  [DomainGraphType.WELL_PLATE_SCHEMA]: '/1/api/well-plate-schemas',
  [DomainGraphType.WORKFLOW_END_NODE_DETAILS]: '/1/api/process-terminal-node-details',
  [DomainGraphType.WORKFLOW_FLOWCHART_CONFIG]: '/1/api/process-flowchart-configs',
  [DomainGraphType.WORKFLOW_FLOWCHART_CONFIG_VERSION]: '/1/api/process-flowchart-config-versions',
  [DomainGraphType.WORKFLOW_FLOWCHART_EDGE_CONFIG]: '/1/api/process-flowchart-edge-configs',
  [DomainGraphType.WORKFLOW_FLOWCHART_NODE_CONFIG]: '/1/api/process-flowchart-node-configs',
  [DomainGraphType.WORKFLOW_OUTPUT]: '/1/api/process-outputs',
  [DomainGraphType.WORKFLOW_OUTPUT_NODE_DETAILS]: '/1/api/process-output-node-details',
  [DomainGraphType.WORKFLOW_OUTPUT_SCHEMA]: '/1/api/process-output-schemas',
  [DomainGraphType.WORKFLOW_ROOT_NODE_DETAILS]: '/1/api/process-root-node-details',
  [DomainGraphType.WORKFLOW_ROUTER_FUNCTION]: '/1/api/process-router-functions',
  [DomainGraphType.WORKFLOW_ROUTER_NODE_DETAILS]: '/1/api/process-router-node-details',
  [DomainGraphType.WORKFLOW_TASK]: '/1/api/process-tasks',
  [DomainGraphType.WORKFLOW_TASK_DEFINITION]: '/1/api/process-task-definitions',
  [DomainGraphType.WORKFLOW_TASK_DEFINITION_VERSION]: '/1/api/process-task-definition-versions',
  [DomainGraphType.WORKFLOW_TASK_GROUP]: '/1/api/processes',
  [DomainGraphType.WORKFLOW_TASK_NODE_DETAILS]: '/1/api/process-task-node-details',
  [DomainGraphType.WORKFLOW_TASK_SCHEMA]: '/1/api/process-task-schemas',
  [DomainGraphType.WORKLIST]: '/1/api/worklists',
  [DomainGraphType.WORKSHEET]: '/1/api/worksheets',
};
